import { useEffect, useRef } from 'react';

/**
 * Reusable Page Loader Component
 * Shows a spinning loader animation that fades out when the page loads
 *
 * This component handles the loader fadeout automatically on mount
 * and can be used across all pages for consistent loading experience
 */
function PageLoader() {
  const loaderRef = useRef(null);

  useEffect(() => {
    // Fade out the loader after component mounts
    const fadeOutLoader = () => {
      // Try jQuery first for smooth animation
      if (window.$ && window.$('.loader1').length > 0) {
        window.$('.loader1').fadeOut(800);
        window.$('.side-menu').removeClass('hidden');
      } else if (loaderRef.current) {
        // Fallback: use CSS transition if jQuery not available
        loaderRef.current.style.transition = 'opacity 0.8s ease-out';
        loaderRef.current.style.opacity = '0';
        setTimeout(() => {
          if (loaderRef.current) {
            loaderRef.current.style.display = 'none';
          }
        }, 800);
      }
    };

    // Wait for jQuery to be available, with timeout fallback
    const waitForJQuery = (callback, maxAttempts = 20) => {
      let attempts = 0;
      const check = () => {
        attempts++;
        if (window.$) {
          callback();
        } else if (attempts < maxAttempts) {
          setTimeout(check, 50);
        } else {
          // jQuery not available after max attempts, use fallback
          callback();
        }
      };
      check();
    };

    // Small delay to show loader briefly, then fade out
    const timer = setTimeout(() => {
      waitForJQuery(fadeOutLoader);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="loader1" ref={loaderRef}>
      <div className="loader-inner">
        <div id="preloader">
          <div id="loader"></div>
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
